/**
 * Product Template 1 - Optimized JavaScript
 * Moved inline scripts to external file for better caching and performance
 */

// Throttle function to limit event execution
function throttle(func, wait) {
  let timeout;
  let lastCallTime = 0;
  return function executedFunction(...args) {
    const now = Date.now();
    const timeSinceLastCall = now - lastCallTime;
    
    if (timeSinceLastCall >= wait) {
      lastCallTime = now;
      func(...args);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        lastCallTime = Date.now();
        func(...args);
      }, wait - timeSinceLastCall);
    }
  };
}

// Sticky photos scroll handler
document.addEventListener('DOMContentLoaded', function() {
  const sticky = document.getElementById('stickyPhotos');
  if (!sticky) return;
  
  const parent = sticky.parentElement; // .col-md-6
  const offsetTop = sticky.getBoundingClientRect().top + window.scrollY;
  const topOffset = 20; // distance from top when fixed
  const maxScrollLimit = window.innerHeight * 0.8; // 120vh in pixels

  function onScroll() {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY + topOffset > offsetTop && scrollY < maxScrollLimit) {
      // Fix position and align width & left to parent container
      const parentRect = parent.getBoundingClientRect();

      sticky.classList.add('fixed');
      sticky.style.position = 'fixed';
      sticky.style.top = topOffset + 'px';
      sticky.style.width = parentRect.width + 'px';
      sticky.style.left = parentRect.left + 'px';
      sticky.style.bottom = 'auto';
    } else if (scrollY >= maxScrollLimit) {
      // Stop fixed and place at bottom limit inside parent container
      sticky.classList.remove('fixed');
      sticky.style.position = 'absolute';
      sticky.style.top = 'auto';
      sticky.style.bottom = '0';
      sticky.style.width = '100%';
      sticky.style.left = '0';
    } else {
      // Normal flow before sticky start
      sticky.classList.remove('fixed');
      sticky.style.position = 'relative';
      sticky.style.top = 'auto';
      sticky.style.bottom = 'auto';
      sticky.style.width = '100%';
      sticky.style.left = 'auto';
    }
  }

  // Throttle scroll to ~60fps (16ms) for smooth performance
  const throttledOnScroll = throttle(onScroll, 16);
  window.addEventListener('scroll', throttledOnScroll, { passive: true });

  // Throttle resize handler as well
  const throttledResize = throttle(() => {
    if (sticky.style.position === 'fixed') {
      const parentRect = parent.getBoundingClientRect();
      sticky.style.width = parentRect.width + 'px';
      sticky.style.left = parentRect.left + 'px';
    }
  }, 100);
  
  window.addEventListener('resize', throttledResize, { passive: true });
});

// Accordion toggle function
function toggleAccordion(button) {
  const content = button.nextElementSibling;
  const iconDown = button.querySelector('.accordion-icon-down');
  const iconUp = button.querySelector('.accordion-icon-up');

  if (content.style.maxHeight && content.style.maxHeight !== '0px') {
    // Close accordion
    content.style.maxHeight = '0px';
    iconDown.style.display = 'block';
    iconUp.style.display = 'none';
  } else {
    // Close any other open accordion
    document.querySelectorAll('.accordion-content').forEach(el => {
      el.style.maxHeight = '0px';
    });
    document.querySelectorAll('.accordion-icon-down').forEach(el => {
      el.style.display = 'block';
    });
    document.querySelectorAll('.accordion-icon-up').forEach(el => {
      el.style.display = 'none';
    });

    // Open this accordion
    content.style.maxHeight = content.scrollHeight + 'px';
    iconDown.style.display = 'none';
    iconUp.style.display = 'block';
  }
}

// Video volume toggle function
function toggleVolume(event, sectionId) {
  // Make 100% sure no event reaches the cart drawer
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const video = document.getElementById('Mp4' + sectionId);
  const iconOn = document.querySelector('.icon-sound-on-' + sectionId);
  const iconOff = document.querySelector('.icon-sound-off-' + sectionId);

  if (video && iconOn && iconOff) {
    if (video.muted) {
      video.muted = false;
      iconOn.style.display = 'inline';
      iconOff.style.display = 'none';
    } else {
      video.muted = true;
      iconOn.style.display = 'none';
      iconOff.style.display = 'inline';
    }
  }
}

// Direct checkout function
function directCheckout() {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) {
    console.error('Product form not found.');
    return;
  }

  let variantId = null;
  
  // First, try to get the ID from the dropdown selector
  const variantSelect = form.querySelector('select[name="id"]');
  if (variantSelect) {
    variantId = variantSelect.value;
  } else {
    // If no dropdown, it's likely a single-variant product with a hidden input
    const hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) {
      variantId = hiddenInput.value;
    }
  }

  const quantityInput = form.querySelector('input[name="quantity"]');
  const qty = quantityInput ? quantityInput.value : 1;

  // Ensure a valid variant ID was actually found before proceeding
  if (variantId && variantId !== '') {
    window.location.href = `/cart/${variantId}:${qty}`;
  } else {
    alert('Please select a product option.');
  }
}

// Alias for toggleMute (backward compatibility)
function toggleMute(sectionId) {
  // Create a synthetic event for toggleVolume
  const event = { preventDefault: () => {}, stopPropagation: () => {}, stopImmediatePropagation: () => {} };
  toggleVolume(event, sectionId);
}

// Make functions globally available
window.toggleAccordion = toggleAccordion;
window.toggleVolume = toggleVolume;
window.toggleMute = toggleMute; // Alias for backward compatibility
window.directCheckout = directCheckout;
